import { useOrgTranslator } from "./useOrgTranslator";

export { useOrgTranslator };
